<template>
  <div class="pnlBulletinsItem">
    <img class="imgBulletins" :src="imgUrl" />
    <label class="lblModelOrder">{{ index + 1 }}</label>
    <label class="lblModel">{{ name }}</label>
    <img
      class="imgModelPartOfBg"
      src="@/assets/img/models/card_celement_B.png"
    />
    <div class="pnlModelHover">
      <div class="pnlModelTool" style>
        <img class="imgModelTool" src="@/assets/img/icon_btn/icon_edit.png" />
        <label class="lblModelTool">{{
          $t("Customize.BtnBulletinRename")
        }}</label>
        <button
          class="btnAbs100"
          @click="EditBulletin()"
        ></button>
      </div>
      <div class="pnlModelTool" style>
        <img class="imgModelTool" src="@/assets/img/icon_btn/icon_delete.png" />
        <label class="lblModelTool">{{
          $t("Customize.BtnBulletinDelete")
        }}</label>
        <button
          class="btnAbs100"
          @click="DelBulletin()"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomModel",
  props: {
    name: String,
    imgUrl: String,
    index: Number,
  },
  methods: {
    EditBulletin(){
      this.$emit("edit-bulletin");
    },
    DelBulletin(){
      this.$emit("del-bulletin");
    },
  },
};
</script>